import {ClockCircleOutlined, InfoCircleOutlined} from '@ant-design/icons';
import successImage from 'assets/images/vendor-register/success.svg';
import {useAppSelector} from 'store';

const RegisterCompleted: React.FC = () => {
  const {registerStatus} = useAppSelector((state) => state.vendorRegistration);

  return (
    <div className="flex flex-1 flex-col bg-white">
      <div className="flex flex-col items-center px-5 py-10 text-center">
        <img className="mb-8" src={successImage} alt="" aria-hidden />
        <h2 className="mb-4 text-heading-h5 text-neutral-fg">ثبت نام شما با موفقیت تکمیل شد!</h2>
        <div className="flex w-full flex-col gap-4 rounded-xl border border-gray-21 bg-gray-15 p-4 text-start">
          <div className="flex items-center gap-3 text-body-sm text-gray-33">
            <InfoCircleOutlined aria-hidden className="shrink-0 text-body-lg text-blue-sky" />
            <span>
              کد پیگیری شما:{' '}
              <strong className="text-body-sm-emphasis text-neutral-fg">
                {registerStatus.trackingNumber}
              </strong>
            </span>
          </div>
          <div className="flex items-center gap-3 text-body-sm text-gray-33">
            <ClockCircleOutlined aria-hidden className="shrink-0 text-body-lg text-blue-sky" />
            <span>
              زمان تکمیل:{' '}
              <strong className="text-body-sm-emphasis text-neutral-fg">
                {new Date().toLocaleDateString('fa-IR')}
              </strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterCompleted;
